import AppUtil from '@/util/AppUtil';
import UrlUtil from '@/util/UrlUtil';
import WxUtil from '@/util/WxUtil';

// import {Toast} from 'vant'
/**门店信息模型*/
export default class UserVo {
  [x: string]: any;
  memberName = "";
  memberPhone = "";
  /**1用户，2会员，3超级会员，4老板（boss） */
  memberLevel = -1;
  private levelArr=["未知身份","用户","会员","超级会员","老板"]
  headImgurl="";
  nickName="";
  /**性别 */
  sex="";
  sexName="";
  birthday="";
  /**总消费金额 */
  allPayMoney=0;
  id=0;
  /**会员卡余额 */
  beautyCardAbleMoney=0;
  /**是否拥有畅享卡 */
  isCxcard=0;
  /**超级会员状态：0不是，1正常超级会员，2冻结 */
  shareholderState=0;
  /**超级会员本人消费是否分红 1.超级会员自己消费分红 2.超级会员折扣价 */
  selfshareoutbonusState=1;
  /**畅享卡二维码地址 */
  cardQrUrl="";
  /**推广二维码 */
  tgQrUrl="";
  private static instance: UserVo; //类型为这个类



  static getInstance() {
    if (!this.instance) {
      this.instance = new UserVo();
      // if(autoInit){
      //   this.instance.req_data();
      // }
      //
    }
    // console.log("返回示例对象",this.instance);

    return this.instance;
  }
 
  /**称呼显示 */
  public get name(){
    return this.memberName||this.nickName
  }

  get levelTxt(){
    if(this.memberLevel<0||this.memberLevel>=this.levelArr.length){
      return "未知身份";
    }
    return this.levelArr[this.memberLevel];
  }
  get thumb(){
    return AppUtil.get_thumb(this.headImgurl);
  }
  get phone(){
    return this.memberPhone||'暂无';
  }
 /**账号（手机）*/
 public get account(){
  return this.memberPhone||'请先完善资料'
}
  // get level(){
  //   // if(!this.id){
  //   //   this.req_data();
  //   // }
  //   return this.memberLevel;
  // }
  /**是否正在请求数据 */
  private loading=false;
  /**获取数据 */
  public req_data( sucessFun: any=null) {
    if(this.loading){
      return;
    }
    this.loading=true;
    AppUtil.request({
      url: "/zhMember/member/getInfoByToken",
      method: "post",
      data:{pid:UrlUtil.getUrlParam("pid")||""}
    }, (res: any) => {
      // this.instance.setData(res.data)
      console.log("设置用户数据",res);
      let data=res.data;
      for (var i in data) { //for in 会遍历对象的属性，包括实例中和原型中的属性。（需要可访问，可枚举属性）
        ( this as any)[i] = data[i];
      }
      this.beautyCardAbleMoney=data.beautyCardAbleMoney||0;//防止后台只返回空""
      if(sucessFun){
        sucessFun()
      }
      
    },"",()=>{
      this.loading=false;
    },()=>{
      //
    });

  }
  /**获取数据,检测401自动登陆 */
  public req_data1( sucessFun: any=null) {
    if(this.loading){
      return;
    }
    this.loading=true;
    AppUtil.request({
      url: "/zhMember/member/getInfoByToken",
      method: "post",
      data:{pid:UrlUtil.getUrlParam("pid")||""}
    }, (res: any) => {
      // this.instance.setData(res.data)
      console.log("设置用户数据",res);
      let data=res.data;
      for (var i in data) { //for in 会遍历对象的属性，包括实例中和原型中的属性。（需要可访问，可枚举属性）
        ( this as any)[i] = data[i];
      }
      this.beautyCardAbleMoney=data.beautyCardAbleMoney||0;//防止后台只返回空""
      if(sucessFun){
        sucessFun()
      }
      
    },"",()=>{
      this.loading=false;
    });

  }
  public set_data(data:any){
    for (var i in data) { //for in 会遍历对象的属性，包括实例中和原型中的属性。（需要可访问，可枚举属性）
      ( this as any)[i] = data[i];
    }
  }
  
}
